import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import theme from "./theme";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Provider } from "react-redux";
import { store } from "./app/store";
import TestComponent from "./TestComponent";

const root = ReactDOM.createRoot(document.getElementById("root"));

if ("serviceWorker" in navigator) {
  const swUrl =
    process.env.REACT_APP_FIREBASE_MESSAGING_SW || "/firebase-messaging-sw.js";

  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // console.log("Service Worker registrado con éxito:", registration);
    })
    .catch((error) => {
      console.log("Error registrando el Service Worker:", error);
    });
}

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Provider store={store}>
          {/* <TestComponent /> */}
          <App />
        </Provider>
      </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
